import Button from "../Button";
import React, {useContext, useEffect, useRef, useState} from "react";
import ProgressLoading from "../loading/ProgressLoading";
import Api from "../../tools/service";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import UserReportedCard from "./UserReportedCard";
import ForeignerAuthenticationContext from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import ForeignerGuide from "./ForeignerGuide";
import ForeignerVideoCamera from "./ForeignerVideoCamera";
import Final from "./Final";

const VideoValidation = () => {
    const foreignerAuthAuthenticationContext = useContext(ForeignerAuthenticationContext);
    const videoValidationWebcam = useRef(null);
    const [showGuide, setShowGuide] = useState(true);
    const [isLoading, setLoading] = useState(false)
    const [step, setStep] = useState(1);
    const [video, setVideo] = useState('')
    const [warning, setWarning] = useState(false)
    const [warningMessage, setWarningMessage] = useState('');
    const [warningTitle, setWarningTitle] = useState('');
    const [loadingMessage,setLoadingMessage]=useState('در حال احراز هویت');
    const [isSuccess,setSuccess]=useState(false)
    useEffect(()=>{
        if(isLoading){
            setTimeout(()=>{
                setLoadingMessage('در حال بارگذاری')
            },5000)
        }

    },[isLoading])
    const [timerCount, setTimerCount] = useState(7)
    if (isLoading) {
        return <ProgressLoading showProgress={true} type="VideoValidation" text={loadingMessage ? loadingMessage :'در حال احراز هویت'}
                                duration={30} theme="green"/>
    }
    const handleCloseGuide=()=>{
        setShowGuide(false)
    }
    const handleVideoValidation = () => {
        setLoading(true);
        /*const imageIndex = nidImage.indexOf(";base64,") + 8;*/
        const videoIndex = video.indexOf(";base64,") + 8;

        handleGenerateUuid('UniqueFace', foreignerAuthAuthenticationContext.token).then((generatedUuid) => {
            if (generatedUuid) {
                Api.post(REQUEST_URLS.DIVAR_FOREIGNER_AUTH.VIDEO_VALIDATION, {
                    pid: foreignerAuthAuthenticationContext.pid,
                    uuid: generatedUuid,
                    Video: video.substr(videoIndex),
                }, {
                    headers: {
                        "Authorization": `Bearer ${foreignerAuthAuthenticationContext.token}`
                    }
                }).then((response) => {

                    const {data, hasError, status, message} = response;

                    if (!hasError) {
                        if (data.warning) {
                            setWarning(true)
                            setWarningMessage(data.warning);
                            setWarningTitle(data.title);
                            setLoading(false)
                        } else {
                            if(status===531){
                                setSuccess(true)
                                /*setWarning(true)
                                setWarningMessage(message);*/
                                setLoading(false)
                            }else {
                                foreignerAuthAuthenticationContext.handleGetProcess(foreignerAuthAuthenticationContext.pid);
                            }

                        }


                    } else {
                        setLoading(false);
                        if (status === 521) {
                            setTimerCount(13)
                        }

                        foreignerAuthAuthenticationContext.handleError({  message:status===-10 || status===-12 ? data.message :message,
                            title: status===-10 || status===-12 ? data.title:null, status, data, callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message: message || 'خطای سرویس',
                                    pid: foreignerAuthAuthenticationContext.pid,
                                    onConfirm: () => {
                                        Reoverlay.hideModal();
                                    },
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonText: 'تلاش مجدد',
                                    confirmButtonText: 'ویرایش اطلاعات',
                                    cancelButtonTheme: 'red',
                                    onCancel: () => {
                                        setShowGuide(false)
                                        setStep(1);
                                        Reoverlay.hideModal();

                                    }
                                })
                            }
                        })

                    }
                }).catch((error) => {
                    console.log(error)
                    setLoading(false)
                }).finally(() => {

                });
            } else {
                setLoading(false)
            }
        }).catch(() => {

        })
    }
    const handlePrev = () => {
        setStep(step - 1)
    }
    const handleCapture = (video) => {
        setVideo(video);
        setStep(step + 1)

    }
    const handleRetry = () => {
        handlePrev()
    }
    const RecordedVideoPreview=()=>{
        return <div className="mx-auto w-full md:h-screen lg:w-4/12 md:w-6/12">
            <h1 className="font-bold text-center mb-3 py-3  text-xl">احراز هویت ویدیویی</h1>
            <div className=" justify-center  flex   flex-col items-center ">
                <div className="w-8/12 md:w-6/12 overflow-hidden flex justify-center items-center">
                    <video   className={"cursor-pointer rounded-lg"} controls onClick={e => e.target.play()}
                           src={video}/>
                </div>
                <p className=" text-green-500   mt-3  bg-green-100 border border-green-400  w-full p-3 rounded-lg mb-3">
                    ویدیو با موفقیت ضبط شد.
                </p>
                <p className="w-full mb-2">لطفاً پیش از ارسال ویدیو، موارد زیر را بررسی کنید. </p>

                <ul className="list-decimal mt-1 w-full   list-inside">
                    <li className="text-sm font-semibold mb-1">آیا عینک خود را برداشته‌اید؟</li>
                    <li className="text-sm font-semibold mb-1">آیا از ماسک استفاده نکرده‌اید؟</li>
                    <li className="text-sm font-semibold mb-1">آیا چهره‌تان کاملاً درون کادر قرار گرفته است؟</li>
                    <li className="text-sm font-semibold mb-1">آیا در نور کافی تصویربرداری کرده‌اید؟</li>
                    <li className="text-sm font-semibold mb-1">آیا از قرار گرفتن پشت به منبع نور خودداری کرده‌اید؟</li>
                </ul>

                <p className="w-full text-red-400 text-sm mt-1">در صورت عدم تطابق با این نکات، ویدیو را دوباره ضبط نمایید</p>
                <div className="w-full fixed md:relative   bg-white md:bg-transparent bottom-0 left-0 md:bottom-auto   md:left-auto mt-5 p-3 md:p-0  grid grid-cols-2 flex justify-center gap-2 items-center">
                    <Button className="text-sm" onClick={handleRetry}  rounded="rounded-lg" theme="light">ضبط مجدد </Button>
                    <Button className="text-sm" onClick={handleVideoValidation}  rounded="rounded-lg"
                            theme="green">تایید و ارسال</Button>

                </div>
            </div>

        </div>
    }
    if (warning) {
        return <UserReportedCard title={warningTitle} reportedMessage={warningMessage}/>
    }
    if(isSuccess){
        return  <Final/>
    }
    return <div className="w-11/12 mx-auto ">
        {showGuide &&  step === 1&&<ForeignerGuide onClose={handleCloseGuide}/>
        }
        {!showGuide && step === 1 &&
            <ForeignerVideoCamera title={'احراز هویت ویدیو'} description={"با در نظر گرفتن نکات زیر، به مدت 7 ثانیه از چهره خود ویدیو بگیرید."} min={timerCount} max={timerCount} webcamRef={videoValidationWebcam}
                          text2={""} text={' متن زیر را با صدای بلند بخوانید'} faceMode="user"
                          onCapture={handleCapture} isVideo={false} type="face"/>
        }
        {!showGuide && step === 2 && <RecordedVideoPreview/>}

    </div>
}
export default VideoValidation;